import React from 'react';

import PillarOverviewSlider from '../../PillarOverviewSlider';

import './style.scss';

const NewsPillarOverview = ({ entities, entity, filters, ...props }) => {
  if (!entity) {
    return null;
  }

  let url = '/nieuws';
  const pillarId = filters.field_pillar_target_id?.[0];

  if (pillarId) {
    url = `/nieuws?pijler=${pillarId}`;
  }

  return (
    <PillarOverviewSlider
      className="NewsPillarOverview"
      url={url}
      subTitle="Bekijk alle nieuwsberichten"
      title={entity.getIn(['field_label', 0, 'value'])}
      body={entity.getIn(['field_text', 0, 'processed'])}
      entities={entities}
      {...props}
    />
  );
};

export default NewsPillarOverview;
